// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__EObh4","breadcrumb-item":"breadcrumb_breadcrumb-item__dsNRc","breadcrumb-disabled":"breadcrumb_breadcrumb-disabled__ppUWN"};